<template>
  <ul class="contact-info">
    <li class="contact-info__title">联系我们</li>
    <li class="contact-info__item">
      <span class="contact-info__label">公司地址：</span>
      <span>{{ company.address }}</span>
    </li>
    <li v-for="(c, index) in company.contacts" :key="index" class="contact-info__item">
      <span class="contact-info__label">联系人：</span>
      <span>{{ c.name }} · <a :href="'tel:' + c.phone" class="contact-info__phone">{{ c.phone }}</a></span>
    </li>
  </ul>
</template>

<script>
import { COMPANY } from '@/constants/company'

export default {
  name: 'ContactInfo',
  data () {
    return { company: COMPANY }
  }
}
</script>

<style lang="scss" scoped>
.contact-info {
  text-align: left;
  margin-bottom: 0;
  list-style: none;
  padding: 0;
  width: 100%;

  &__title {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.25rem;
    color: inherit;
  }

  &__item {
    margin-bottom: 0.75rem;
    font-size: 1.0625rem;
    line-height: 1.6;
  }

  &__label {
    display: inline-block;
    min-width: 5.625rem;
  }

  &__phone {
    color: var(--color-primary);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
